import { DrawerObject } from '@/components/drawer/drawer.types';
import { FormBuilderComponent } from '@/components/form-builder/form-builder.component';
import { DynamicForm } from '@/components/form-builder/form-builder.types';
import { ApprovalTypeRepository } from '@/store/approval-type-state/approval-type-state.repository';

interface IgetApprovalTypeUpdateDrawerObjectProps {
  store?: ApprovalTypeRepository;
  formObject?: DynamicForm;
  toggleVisibility?: () => void;
  action?: () => void;
}

export const getApprovalTypeUpdateDrawerObject = ({
  store,
  formObject,
  toggleVisibility,
  action,
}: IgetApprovalTypeUpdateDrawerObjectProps): DrawerObject => {
  return {
    title: 'settings.approvalType.update.title',
    description: '',
    component: {
      outlet: FormBuilderComponent,
      props: {
        formObject,
      },
    },
    onHide: () => {
      store?.reset();
    },
    actions: [
      {
        label: 'settings.approvalType.update.update',
        onClick: () => action?.(),
        disabled: store?.getObservable<boolean>('isEqual'),
      },
      {
        label: 'settings.approvalType.update.cancel',
        onClick: () => {
          toggleVisibility?.();
          store?.reset();
        },
        variant: 'secondary',
      },
    ],
  };
};
